'use strict';

const React = require('react/addons'),
    {t} = require('services/i18nextWrapper'),
    TankStore = require('stores/TankStore'),
    Notification = require('components/Notification/Notification'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    Loading = require('components/Commons/Loading/Loading'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    PositionUtils = require('utils/PositionUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    Authentication = require('services/Security').Authentication,
    AppConstants = require('constants/AppConstants'),
    {Navigation} = require('react-router'),
    ga = require('react-ga'),
    get = require('lodash/object').get,
    {delay} = require('lodash/function'),
    InventoryStore = require('stores/InventoryStore'),
    {find, filter, map} = require('lodash/collection'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const pageUrl = '/tanks/page/';

const TankAdmin = React.createClass({displayName: "TankAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedItem: null,
            selectedItemId: null,
            isEditMode: false,
            isFetching: true,
            filter: {name: '', section: '', volume: ''}
        };
    },

    componentDidMount() {
        this.fetchTanks();
        ga.pageview('tank-admin');
        document.addEventListener('i18nextLoaded', this.onI18NLoaded);
    },

    componentWillMount(){
        document.removeEventListener('i18nextLoaded', this.onI18NLoaded);
    },

    fetchTanks() {
        const self = this;
        TankStore.fetchTanks(() => {
            self.setState({
                tanks: this._hydrateTanks(ContentUtils.filterEnable(DashboardServiceCache.getTanks())),
                selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
                isFetching: false
            }, self._onFinishRenderingFetchTanks);
        });
    },

    fetchTanksBy(filter) {
        const self = this;
        TankStore.fetchTanksBy(filter, () => {
            self.setState({
                tanks: this._hydrateTanks(ContentUtils.filterEnable(DashboardServiceCache.getTanks())),
                selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
                isFetching: false
            });
        });
    },

    _onFinishRenderingFetchTanks() {
        const {selectedItemId, locationItems} = this.state;
        const haveProductSelectedTable = !!selectedItemId;

        if (haveProductSelectedTable) {
            const self = this;
            this.setState({
                selectedItemId: find(locationItems, locationItem => get(locationItem, 'id') === +selectedItemId)
            }, () => {
                self._setPositionScrollById.bind(self)(selectedItemId);
            });
        }
    },

    _hydrateTanks(tanks) {
        return map(tanks, tank => {
            const tankUnit = get(tank, 'unit', AppConstants.DEFAULT_TANK_UNIT);
            tank.volumeWithUnit = get(tank, 'volume') + (tankUnit ? (' ' + tankUnit) : '');
            tank.unit = tankUnit;
            return tank;
        });
    },

    _setPositionScrollById(selectedTankId) {
        const tableEl = this.getDOMNode().querySelector('.mui-body-table');
        const rowEl = tableEl.querySelector(`tr[data-row-id="${selectedTankId}"]`);
        const positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
        tableEl.scrollTop = positionTopRowEl;
    },

    _onDeleteTank(tank, onSuccess) {
        const tankWillDelete = find(TankStore.getTanks(), tankFilter => tankFilter.id === tank);

        if (filter(TankStore.getTanks(), tankFilter => tankFilter.type === tankWillDelete.type).length === 1) {
            CustomDialog.showInfo(t('signup_error'), t('tank_error_at_least_one_tank_per_section'));
            return;
        }

        CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_delete_tank'), () => {
            TankStore.deleteTank(tank, onSuccess, this.__onFailureShowMessageError);
        });
    },

    _onChangeTank(tank, onSuccess) {
        const isBrewingTank = get(tank, 'type') === 'BH';
        const isVolumeChanged = get(tank, 'volume') !== get(this.state, 'selectedItem.volume');
        if (isBrewingTank && isVolumeChanged) {
            CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_change_volume'), () => {
                TankStore.changeTank(tank, onSuccess, this._onFailure);
            });
        } else {
            TankStore.changeTank(tank, onSuccess, this._onFailure);
        }
    },

    _onAddTank(tank, onSuccess, onFailure) {
        const isBrewingTank = tank && tank.type === 'BH';
        const tanks = get(this.state, 'tanks');
        const currentBrewing = find(tanks, tank => get(tank, 'type') === 'BH');
        const haveTheSameVolume = currentBrewing && get(currentBrewing, 'volume') === get(tank, 'volume');
        if (isBrewingTank && !haveTheSameVolume) {
            CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_change_volume'), () => {
                TankStore.addTank(tank, onSuccess, onFailure);
            });
        } else {
            TankStore.addTank(tank, onSuccess, onFailure);
        }
    },

    _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
        this.setState({
            selectedItem: item,
            isEditMode: !!item,
            headerActiveFilters
        }, () => {
            // stay the position of the scroll after row select when
            // the offset Y es outside of initial viewport page.
            this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;

            this._addQueryParamWithRowSelected(item, lastRowScrollPosition);
        });
    },

    _addQueryParamWithRowSelected(selectedItem, lastRowScrollPosition) {
        this.transitionTo(getCurrentUrl(),
            {},
            {
                selectedItemId: get(selectedItem, 'id')
            }
        );
        // Is needed to force scroll position again
        // in order to avoid jumping scroll behavior
        delay(() => {
            this.getDOMNode().querySelector(
                '.mui-body-table'
            ).scrollTop = lastRowScrollPosition;
        }, 1);
    },

    _onCancel() {
        this.transitionTo(getCurrentUrl());
        this.setState({
            selectedItem: null,
            isEditMode: false,
            filter: {name: '', section: '', volume: ''}
        });
    },

    _onFailure(messageInfo) {
        if (messageInfo) {
            const messageError = ContentUtils.formatMessageError(messageInfo);
            Notification.show(messageError);
        }
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _onTypingFilter(name, match) {
        if (!this.state.isFetching) {
            this.setState(prevState => {
                let nextFilter = prevState.filter || {};
                nextFilter[name] = match;
                this.fetchTanksBy(nextFilter);
                return {
                    filter: nextFilter,
                    isFetching: true
                };
            });
        }
    },

    _printReport() {
        InventoryStore.downloadReportXLS(this.state.filter, 'tanks');
    },

    render() {
        if (!this.state.tanks) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('tank_admin_change_message_success'),
                changeFailureMessage: t('tank_admin_change_message_failure'),
                deleteSuccessMessage: t('tank_admin_delete_message_success'),
                addSuccessMessage: t('tank_admin_add_message_success'),
                addFailureMessage: t('tank_admin_add_message_failure')
            };
            const contextHolder = this.getContextHolderInstance();
            const {selectedItem, tanks, isEditMode} = this.state;
    
            const currentSelectedSection = selectedItem && selectedItem.section
              ? AppConstants.getSectionsMapping(t)[selectedItem.section]
              : '';
    
            const currentSelectedCategoryValue = currentSelectedSection
              ? Object.assign({}, selectedItem, {displayText: currentSelectedSection})
              : selectedItem;
            
            const unit = get(selectedItem, 'unit');
            const unitWithParenthesis = unit ? '(' + unit + ')' : '';
            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "name", 
                    name: t('tank_label_name'), 
                    value: selectedItem, 
                    label: t('tank_placeholder_name'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupDropdown, {
                    isFullRelaxedText: true, 
                    items: AppConstants.getSections(t), 
                    operationsHolder: contextHolder, 
                    readerAttribute: "displayText", 
                    customReaderWriterAttribute: "section", 
                    readerAttributeValue: "section", 
                    writerAttribute: "type", 
                    outputMapper: {
                        Fermenting: 'FV',
                        Packaging: 'BT',
                        Brewing: 'BH'
                    }, 
                    name: t('tank_label_section'), 
                    isImmutable: true, 
                    value: currentSelectedCategoryValue, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "volume", 
                    additionalValidation: inputValue => NumberUtils.isNumber(inputValue) ? (containSomeDecimalValueDigit(inputValue) ? t('tank_admin_decimal_not_supported') : '') : t('tank_admin_must_be_number'), 
                    name: t('tank_label_volume'), 
                    value: selectedItem, 
                    label: `${t('tank_label_volume')} ${unitWithParenthesis}`, 
                    isRelaxedText: true, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "unit", 
                    isRelaxedText: true, 
                    name: t('tank_label_unit'), 
                    value: selectedItem || {unit: DashboardServiceCache.getCurrentUnitTank()}, 
                    label: t('tank_label_unit'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement(AdminScaffolding, {
                    moduleName: "ADMIN_TANK", 
                    messages: messages, 
                    title: t('dashboard_sidebar_tanks_sections'), 
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems: this.fetchTanks, 
                    headerFields: formFieldsEl, 
                    onAdd: this._onAddTank, 
                    onChange: this._onChangeTank, 
                    onCancel: this._onCancel, 
                    onDelete: this._onDeleteTank, 
                    addEnterKeyDown: this._addEnterKeyDown, 
                    isDark: true
                }, 
                    React.createElement(AdminScaffoldingTable, {
                        onRowSelection: this._onRowSelection, 
                        value: selectedItem, 
                        filteredColumns: ['name', 'volumeWithUnit'], 
                        displayAttributes: ['name', 'displaySection', 'volumeWithUnit'], 
                        columnNames: [
                            t('tank_label_name'),
                            t('tank_label_section'),
                            t('tank_label_volume_with_unit')
                        ]
                    }, 
                        tanks.map(tank => {
                            tank.displaySection = AppConstants.getSectionsMapping(t)[tank.section];
                            return tank;
                        })
                    )
                ));
        }
    }
});

function getCurrentUrl() {
    return pageUrl + NavigationUtils.getPathParam('page');
}

function containSomeDecimalValueDigit(value) {
    if (value && value.indexOf) {
        return value.indexOf('.') > -1 || value.indexOf(',') > -1;
    }
    return false;
}

module.exports = TankAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/TankAdmin/TankAdmin.jsx
 **/